import { render, staticRenderFns } from "./SimpleDocumentationList.vue?vue&type=template&id=dea7c1b4&"
import script from "./SimpleDocumentationList.vue?vue&type=script&lang=js&"
export * from "./SimpleDocumentationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports